import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import BottomNavBar from './BottomNavBar';
import SideNavBar from './SideNavBar';

/**
 * @file MainLayout.tsx
 * @brief Hauptlayout-Komponente der Anwendung, die die Navigation und den Inhaltsbereich verwaltet.
 *
 * Diese Komponente passt das Layout basierend auf der Bildschirmgröße an und zeigt entweder eine
 * seitliche Navigationsleiste (für Desktops) oder eine untere Navigationsleiste (für Mobilgeräte) an.
 * Der Hauptinhaltsbereich wird über das `Outlet` von `react-router-dom` gerendert.
 *
 * @returns {JSX.Element} Ein React-Element, das das Hauptlayout der Anwendung darstellt.
 */
const MainLayout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="d-flex flex-column flex-md-row min-vh-100">
      {!isMobile && <SideNavBar />}
      <main className="content-area flex-grow-1 p-3">
        <Outlet />
      </main>
      {isMobile && <BottomNavBar />}
    </div>
  );
};

export default MainLayout;
